import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import { Textbox } from "react-inputs-validation";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";

class ExpTypeAddEdit extends Component {
  constructor(props) {
    super(props);

    var _expType, _mode, _hasNameError;
    if (this.props.pData._id === "NA") {
      _expType = "";
      _hasNameError = true;
      _mode = "add";
    } else {
      _expType = this.props.pData.expType;
      _hasNameError = false;
      _mode = "edit";
    }

    this.state = {
      expType: _expType,
      spinnerClass: "collapse",
      dataClass: "",
      validate: false,
      hasNameError: _hasNameError,
      mode: _mode
    };
  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Expense Type</div>
              <div className="col col-md-3">
                <Textbox
                  value={this.state.expType}
                  placeholder="Enter Expense Type"
                  onChange={(expType, e) => {
                    this.setState({ expType });
                  }}
                  onBlur={e => {}}
                  validationOption={{
                    name: "Expense Type",
                    check: true,
                    required: true
                  }}
                  validate={this.state.validate}
                  validationCallback={res =>
                    this.setState({ hasNameError: res, validate: false })
                  }
                />
              </div>
            </div>
            <div className="row p-1 border">
              <button
                onClick={this.onSaveClick}
                className="btn btn-primary btn-md mr-2"
              >
                Save
              </button>
              <button
                onClick={this.onClearClick}
                className="btn btn-primary btn-md mr-2"
              >
                Clear
              </button>
              <button
                onClick={this.onCancelClick}
                className="btn btn-primary btn-md mr-2"
              >
                Cancel
              </button>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    if (typeof this.state._id === "undefined" || this.state._id === "") {
      return "Add New Expense Type";
    } else {
      return "Edit Expense Type " + this.state.expType;
    }
  }

  onSaveClick = async e => {
    e.preventDefault();
    this.toggleValidating(true);

    if (!this.state.hasNameError) {
      const obj = {
        expType: this.state.expType
      };
      if (this.state.mode === "add") {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/ExpType/add",
            obj
          )
          .then(res => console.log(res.data));
        this.toggleValidating(false);
        this.setState({ hasNameError: true });
        this.ClearData();
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Expense Type Added !!!"
        });
      } else {
        axios
          .post(
            (process.env.NODE_ENV !== "development"
              ? appConst.API_URL_PROD
              : appConst.API_URL_DEV) +
              
              "/ExpType/update/" +
              this.props.pData._id,
            obj
          )
          .then(res => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Expense Type Updated !!!"
            });
            this.props.onClick("List", null);
          });
      }
    }
  };

  toggleValidating(validate) {
    this.setState({ validate });
  }

  ClearData() {
    this.setState({ expType: "", hasNameError: true });
  }

  onClearClick = e => {
    this.ClearData();
    this.growl.show({
      severity: "success",
      summary: "Success",
      detail: "Data Cleared !!!"
    });
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default ExpTypeAddEdit;
